import type { ViewModel } from "./types";

// Webpack evaluates modules only once, so this object will act as a global
// object for reading/writing essentially making this act like a singleton in
// other languages.
export const viewModel: ViewModel = {};
